import React from "react";
import CostReportPage from "./CostReportPage";
import { RouteProps } from "react-router-dom";
import { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface CostReportPageContainerProps extends RouteProps, withValidUserRoleProps {}

const CostReportPageContainer = (props: CostReportPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <CostReportPage title={getTitle()} category={getType()} />;
};

export default CostReportPageContainer;
